import React from "react"
import PropTypes from "prop-types"
import { createUseStyles } from "react-jss"
import { Anchor } from "../app/components/anchor"
import colors from "../styles/colors"
import { fontWeight, fontSize } from "../styles/fonts-constants"

const useStyles = createUseStyles({
  driverShipmentCard: {
    flexGrow: 1,
    border: `1px solid ${colors.gray2}`,
    borderRadius: 2,
    backgroundColor: colors.white1,
    marginBottom: 30,
    padding: 18,
    minHeight: "180px",
  },
  fonts: {
    fontSize: fontSize.extraSmall,
    fontWeight: fontWeight.bold,
  },
  "cs-title": {
    extend: "fonts",
    lineHeight: 1.56,
    display: "block",
    marginTop: 15,
    marginBottom: 16,
    minHeight: "50px",
  },
  cntTxt: {
    display: "block",
    extend: "fonts",
    lineHeight: 1.56,
    color: colors.gray1,
    minHeight: "60px",
    position: "relative",
    marginTop: 15,
    zIndex: 1,
  },
  amount: {
    extend: "fonts",
    color: colors.gray1,
    backgroundColor: colors.yellow4,

    display: "block",
    textAlign: "center",
    width: 60,
    height: 52,
    borderRadius: "50%",
    padding: "14px 7px",
    opacity: 0.8,
    marginTop: 0,
    marginLeft: -5,
    zIndex: -1,
  },
})

const DriverShipmentCard = (props) => {
  const { title, content, amount, url, mil } = props

  const classes = useStyles()

  return (
    <div className="p-4 border border-gray2 bg-white flex flex-col">
      {url ? (
        <Anchor className={classes.title} href={url} rel="nofollow">
          {title + `(${mil} mi)`}
        </Anchor>
      ) : (
        <h5 className="text-base font-medium text-blue7">
          {title + ` (${mil} mi) `}
        </h5>
      )}
      <p className="my-4 text-base font-medium">{content}</p>
      <p className="h-14 w-16 m-0 mt-auto rounded-full bg-yellow4 text-gray1 flex items-center justify-center">
        {amount}
      </p>
    </div>
  )
}

DriverShipmentCard.propTypes = {
  label: PropTypes.string,
  content: PropTypes.string,
  amount: PropTypes.string,
}

export default DriverShipmentCard
